<h2 mat-dialog-title>
  Automatik
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
  <p>Automatik gør det muligt for kunden at automatisere forskellige handlinger, fx at tilknytte eller fjerne tags baseret på bestemte handlinger.</p>
  @if (automation$ | async; as automation) {
    <form [formGroup]="form">
      <div>
        <mat-form-field class="automation-settings-select">
          <mat-label>Triggers</mat-label>
          <mat-select formControlName="triggers" multiple placeholder="Vælg triggers">
            @for (group of automation.trigger_groups; track group) {
              <mat-optgroup [label]="group.label">
                @for (trigger of group.triggers; track trigger) {
                  <mat-option [value]="trigger.value">{{trigger.label}}</mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
          <mat-error>Vælg <strong>mindst</strong> 1 trigger.</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="automation-settings-select">
          <mat-label>Handlinger</mat-label>
          <mat-select formControlName="actions" multiple placeholder="Vælg handlinger">
            @for (action of automation.actions; track action) {
              <mat-option [value]="action.value">{{action.label}}</mat-option>
            }
          </mat-select>
          <mat-error>Vælg <strong>mindst</strong> 1 handling.</mat-error>
        </mat-form-field>
      </div>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
</mat-dialog-actions>
